import { t } from "i18next";
import { getCurrentSiteCode } from "../../utils";
import { getSdkURL } from "../../services";

const OauthGoogleLogin = ({ buttonText }) => {
  //get site code
  const siteCode = getCurrentSiteCode();
  //set redirect url
  const redirectURL =
    getSdkURL() + "?slatAction=main.OAuthLoginStorefrontHandler&integrationName=googlelogin&siteCode=" + siteCode;

  return (
    <div id="googleLogin" className="customGPlusSignIn" onClick={() => window.location.replace(redirectURL)}>
      <span className="icon"></span>
      <span className="buttonText">{buttonText || t("frontend.oauth.googlesignin")}</span>
    </div>
  );
};

export { OauthGoogleLogin };
